import axios from 'axios'
import { configureBasicAPI } from '../configuration/basic'
import { AxiosApi } from './axiosApi'

export class BasicAPI extends AxiosApi {
  constructor({ domain }: { domain: string }) {
    super(configureBasicAPI(domain))
  }
}

export class BasicHttpRequest extends AxiosApi {
  constructor() {
    super(axios)
  }
}
